import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { formatCurrency } from '../../../utils';

const DifferedValueCard = ({ value }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                mb: isMobile ? 2 : 3,
                pb: isMobile ? 2 : 3,
                borderBottom: '1px solid #f0f0f0',
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: isMobile ? 'flex-start' : 'center',
                pl: 0.5,
            }}
        >
            <Typography
                component="div"
                sx={{
                    fontWeight: 400,
                    color: '#5b616e',
                    mr: 1.5,
                    fontSize: isMobile ? '0.8rem' : '0.875rem',
                    mb: isMobile ? 0.5 : 0,
                }}
            >
                Projects Total Differed Value:
            </Typography>
            <Typography
                component="div"
                sx={{
                    fontWeight: 500,
                    color: '#0a0b0d',
                    fontSize: isMobile ? '0.95rem' : '0.875rem',
                }}
            >
                {formatCurrency(value)}
            </Typography>
        </Box>
    );
};

export default DifferedValueCard;
